/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from "react";
import {PersonOutlinedChip} from "../../../../../../../components/buttons/IconButtons";
import CustomUserChip from "../../../../../../../components/CustomUserChip";
import CustomTooltip from "../../../../../../../components/CustomTooltip";
import {POSITION_MODEL} from "../../../../../../../Helpers/PositionModel";
import {DATE_TIME_FORMAT_NAME_MODEL, getDateFormat} from "../../../../../../../Apis/functions";

/**
 * Chip of the user that registered a value of the gate log. The name and the
 * date are only known once the movement is closed, so they are shown in a
 * tooltip when they are informed.
 */
const RegisteredByChip = ({Icon = PersonOutlinedChip, name, date}) => {
    const chip = (
        <CustomUserChip
            className='m-0 p-0 chip-secondary-150-50-600'
            Icon={Icon}
            showAvatar={true}
            // Every icon of the log is read at the same size, because each one
            // is drawn with the measure of the family it comes from
            classNameIcon={'icon-color-secondary-600 w-h-16px'}
            variant='compact'
            iconPosition={POSITION_MODEL.LEFT}
        />
    );

    if (!name)
        return chip;

    return (
        <CustomTooltip
            text={<>
                <p className={"ibl-font-w-600 fs-14px"}>{name}</p>
                <p className={"fs-14px"}>{getDateFormat(date, null, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}</p>
            </>}
            placement={"top"}
        >
            <span className={"d-inline-flex"}>{chip}</span>
        </CustomTooltip>
    );
};

export default RegisteredByChip;
